module.exports = "https://web-assets-production.autolist.com/_next/static/images/new-york-ny-4c2e2c95130e4813e0f30c7e2bbdeb9e.jpg";